import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { markErrorAsHandled } from '@confluence/graphql-error-processor/entry-points/GraphqlErrorProcessor.ts';
import { expVal } from '@confluence/feature-experiments';

import { SpaceRestrictionCheckQuery } from './SpaceRestrictionCheckQuery.graphql.ts';
import type {
	SpaceRestrictionCheckQuery as Q,
	SpaceRestrictionCheckQueryVariables as V,
} from './__types__/SpaceRestrictionCheckQuery.ts';

export async function preloadSpaceRestrictionCheck(spaceKey: string) {
	if (expVal('confluence_restrictions_fix', 'isEnabled', false)) {
		const result = await query<Q, V>({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: SpaceRestrictionCheckQuery,
			variables: { spaceKey },
			errorPolicy: 'all',
			// Preloaders are called both on server at initial load AND transition on client-side.
			// On server-side it doesn't matter fetch policy because we only gonna request once.
			// On client-side it must be network-only to get fresh data.
			// At usage we use getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery to get from preloaded cache.
			fetchPolicy: 'network-only',
		});

		window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
		window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
		if (result?.errors) {
			result.errors.forEach((error: any) => {
				const status_code = error?.extensions?.statusCode;
				if (status_code === 403) {
					window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
					markErrorAsHandled(error);
				} else if (status_code === 404 || status_code === 400) {
					window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
					markErrorAsHandled(error);
				}
			});
		}
	} else {
		const queryResult = query<Q, V>({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: SpaceRestrictionCheckQuery,
			variables: { spaceKey },
			errorPolicy: 'all',
			fetchPolicy: 'network-only',
		}) as Promise<{ data: Q | null; hasErrors: boolean; errors?: any[] }>;
		return queryResult.then(
			(result) => {
				window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
				window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
				if (result?.errors) {
					result.errors.forEach((error: any) => {
						const status_code = error?.extensions?.statusCode;
						if (status_code === 403) {
							window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
							markErrorAsHandled(error);
						} else if (status_code === 404 || status_code === 400) {
							window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
							markErrorAsHandled(error);
						}
					});
				}
				return result;
			},
			(error) => {
				return Promise.reject(error);
			},
		);
	}
}
